import React from 'react';
import './PartnerSteps.css';

const PartnerSteps = () => {
  const steps = [
    {
      number: '01',
      icon: '📝',
      title: 'Apply Using the Form',
      description: 'Submit your application through our partner application form to get started'
    },
    {
      number: '02',
      icon: '✍️',
      title: 'Fill in All the Details',
      description: 'Complete all required information in the application form with accurate details'
    },
    {
      number: '03',
      icon: '👥',
      title: 'Team Contacts & Validation',
      description: 'Our team will reach out to you and validate all the details you provided'
    },
    {
      number: '04',
      icon: '🚀',
      title: 'Onboard as a Partner',
      description: 'Once validated, you will be onboarded as a Hopmate partner and can start earning'
    }
  ];

  return (
    <section className="partner-steps">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">How to Become a Hopmate Partner</h2>
          <p className="section-description">
            A simple four-step process to start your creator journey with us
          </p>
        </div>
        <div className="partner-steps-grid">
          {steps.map((step, index) => (
            <div key={index} className="partner-step-card">
              <div className="step-number">{step.number}</div>
              <div className="step-icon">
                <span>{step.icon}</span>
              </div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerSteps;

